var RE = /^(Webkit|Moz|O|ms)/;
export default function isPrefixedProperty(property) {
  return RE.test(property);
}


// WEBPACK FOOTER //
// ./node_modules/css-in-js-utils/es/isPrefixedProperty.js